import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TopicListVisibleService {
  change$ = new Subject<boolean>();

  public toggle(change: boolean): void {
    this.change$.next(change);
  }
}
